import React from 'react'
import styled from 'styled-components'
import { IconButton } from '../Styleguide/Button'

type ActionIconProps = {
  iconName: string
  disabled?: boolean
  className?: string
  tooltipText: string
  onClick?: () => void
}

export const ActionIcon: React.FC<ActionIconProps> = ({
  disabled,
  iconName,
  className,
  tooltipText,
  onClick = () => {}
}) => {
  return (
    <StyledIconButton
      iconName={iconName as any}
      className={className}
      tooltipText={tooltipText}
      disabled={disabled || !onClick}
      onClick={onClick}
    />
  )
}

const StyledIconButton = styled(IconButton).attrs({
  iconSize: 15
})`
  && {
    padding: 0;
    width: 36px;
    height: 36px;
    min-width: 36px;
    margin-right: 6px;
    background: #ffffff;
  }

  &:last-child {
    margin-right: 0;
  }
`
